import {Fragment} from 'react';
import {connect} from 'react-redux';

import Portal from 'topmeteo/general/components/Portal';

import WeatherImage from './WeatherImage';

const WeatherImageController = ({region, opacity, zIndex}) => {
    const {id, projection: {extent}, projectionName, url} = region;

    return (
        <Fragment>
            <WeatherImage url={url} projection={projectionName} extent={extent} opacity={opacity} zIndex={zIndex} />
            <Portal container="map-wrapper">
                <p id="current-region-identifier">{id}</p>
            </Portal>
        </Fragment>
    );
};

const mapStateToProps = ({OSMOpacity}) => ({opacity: OSMOpacity});

export default connect(mapStateToProps)(WeatherImageController);
